import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CarteraService } from 'app/services/cartera/cartera.service';

@Component({
  selector: 'app-debito-auto',
  templateUrl: './debito-auto.component.html',
  styleUrls: ['./debito-auto.component.scss']
})
export class DebitoAutoComponent implements OnInit {
  public debito_auto: string;

  constructor(@Inject(MAT_DIALOG_DATA) private _data, private _dialog:MatDialogRef<DebitoAutoComponent>, private _snackBar: MatSnackBar, private _cartera: CarteraService) {
    if(_data.debitoAuto){
      this.debito_auto = _data.debitoAuto.toString();
    }
  }

  ngOnInit() {
  }

  public guardarDebitoAuto(){
    this._cartera.GuardarDebitoAuto(this.debito_auto, this._data.codigo, this._data.codigo, this._data.empresa).subscribe((data: any) => {
      if(data.affectedRows == 1){
        this._snackBar.open('Débito Actualizado', 'Aceptar', {
          duration: 2000
        });
        this._dialog.close(true);
      }else{
        this._snackBar.open('Error al actualizar el Débito.', 'Aceptar', {
          duration: 2000
        });
      }
    });
  }
}
